import { useEffect } from 'react';
import useStore from '../../Store/useStore';
import { removeFaIconCache } from '../../Utils/Cache';
import { setOrderDetails } from '../../Store/actions/LocalCacheActions';
import preval from 'preval.macro';
import usePromotion from '../usePromotion';

//* Build time
const cur_version = preval`module.exports = new Date().getTime();`;

export const checkForCacheInvalidation = () => {
	let isInvalidate = false;
	const pre_version = localStorage.getItem('BUILD_VERSION');
	if (!pre_version) isInvalidate = true;

	localStorage.setItem('BUILD_VERSION', cur_version);
	return isInvalidate;
};

const useCacheInvalidator = () => {
	const { dispatch } = useStore();

	const onInvalidate = () => {
		dispatch(setOrderDetails({}));
		removeFaIconCache();
		// localStorage?.clear();
	};

	const promotion = usePromotion();

	useEffect(() => {
		const isInvalidated = checkForCacheInvalidation();
		if (!isInvalidated || window.MODE === 'LOCAL') return;
		onInvalidate();
		console.log('✅🔃 Assets cache refreshed successfully!');
	}, []);

	//? Cart items carry the promotion's prices, so they are dropped whenever the promotion flips
	useEffect(() => {
		if (!promotion.loaded) return;
		const cur_is_promotion = `${promotion.active}`;
		const pre_is_promotion = localStorage.getItem('CUR_IS_PROMOTION');
		localStorage.setItem('CUR_IS_PROMOTION', cur_is_promotion);
		if (pre_is_promotion === null || pre_is_promotion === cur_is_promotion || window.MODE === 'LOCAL') return;
		onInvalidate();
	}, [promotion.loaded, promotion.active]);
};

export default useCacheInvalidator;
